import React from 'react';

const SkillCategory = ({ title, skills }) => (
  <div className="bg-white bg-opacity-10 rounded-2xl shadow-xl p-8 transition duration-500 hover:shadow-blue-500/30">
    <h3 className="text-2xl font-semibold mb-4 text-blue-300 border-b border-blue-500 pb-2">
      {title}
    </h3>
    <div className="flex flex-wrap gap-3 mt-4">
      {skills.map((skill, index) => (
        <span
          key={index}
          className="bg-blue-900 bg-opacity-30 text-blue-100 px-4 py-1.5 rounded-full text-sm font-medium hover:bg-opacity-40 transition duration-300"
        >
          {skill}
        </span>
      ))}
    </div>
  </div>
);

const Skills = () => {
  const skillCategories = [
    {
      title: 'Programming Languages',
      skills: ['Python', 'JavaScript', 'R', 'Java', 'C', 'SQL'],
    },
    {
      title: 'Data Pipelines',
      skills: ['Apache Spark', 'PySpark', 'Kafka', 'Hadoop'],
    },
    {
      title: 'Databases',
      skills: ['MongoDB', 'Firebase', 'MySQL'],
    },
    {
      title: 'Web & App Development',
      skills: ['React', 'React Native', 'Node.js', 'Express', 'Spring Boot', 'Flask'],
    },
    {
      title: 'Machine Learning & AI',
      skills: ['PyTorch', 'TensorFlow', 'Scikit-learn', 'OpenCV', 'Pandas', 'NumPy', 'LangChain'],
    },
    {
      title: 'DevOps & Tools',
      skills: ['Git', 'Docker', 'Kubernetes'],
    },
  ];

  return (
    <section id="skills" className="py-20 bg-gradient-to-b from-gray-900 to-gray-900">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold mb-16 text-center text-blue-300">
          Skills
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          {skillCategories.map((category, index) => (
            <SkillCategory key={index} {...category} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
